import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
  fetchShippingLabels,
  fetchCP,
  fetchActiveReportsMetaData,
  fetchSampleTemplates,
  uploadFileToS3,
  preSignedUrl,
  postShippingLabels,
  replicateS3File,
  putShippingLabels
} from '../actions/sessionActions';
import { Select, Radio, Button, Row, Col, message } from 'antd';
const { Option } = Select;
import { getBase64, parseQueryString } from '../utils/assetUtils';

const labelSizes = [
  { label: 'A4', value: 'A4' },
  { label: 'A6', value: 'A6' },
  { label: '6X4', value: '6X4' }
];

export class CreateShippingLabels extends Component {
  state = {
    formInput: {
      enterprise: null,
      cps: [],
      accounts: [],
      sampleTemplate: '',
      file: {},
      labelSize: ''
    },
    result: [],
    isSubmitting: false
  };
  htmlTemplate = React.createRef();
  componentWillMount = () => {
    this.props.fetchActiveReportsMetaData('enterprise');
    const queryParams = parseQueryString(this.props.location.search);
    this.setState({ queryParams });
    if (queryParams.key) {
      this.props.fetchShippingLabels(queryParams);
    }
    this.props.fetchSampleTemplates();
  };

  handleChange = (key, value) => {
    const { formInput } = this.state;
    const { metadata } = this.props;
    if (key === 'enterprise') {
      const enterprise = metadata.enterprise.list[value];
      formInput[key] = enterprise;
      this.props.fetchCP(enterprise);
      formInput.cps = [];
      formInput.accounts = [];
    } else {
      formInput[key] = value;
    }
    if (key === 'cps') {
      formInput.accounts = [];
    }
    this.setState({ formInput });
  };

  handleRadioChange = e => {
    const { formInput } = this.state;
    formInput[e.target.name] = e.target.value;
    formInput.file = {};
    this.htmlTemplate.current.value = null;
    this.setState({ formInput });
  };

  fileSelect = e => {
    const { formInput } = this.state;
    formInput.file = e.target.files[0];
    formInput.sampleTemplate = '';
    this.setState({ formInput });
  };

  shipppingLabelCreation = data => {
    const promiseArray = data.map(obj => this.props.postShippingLabels(obj));
    return Promise.all(promiseArray).then(async res => {
      for (let index = 0; index < data.length; index++) {
        if (res[index].meta.status === 422) {
          data[index].status = 'Failed';
          data[index].message = res[index].meta.message;
          data[index].id = res[index].result.id;
        } else if (res[index].meta.status === 200) {
          data[index].status = 'Success';
        }
      }
      // this.handleReset();
      this.setState({ result: data, isSubmitting: false });
      if (res[0].meta.status === 200) {
        message.success('Your data has been successfully submitted.');
      } else {
        message.error(res.meta.message);
      }
    });
  };

  handleSubmit = () => {
    const { shippingLabels } = this.props;
    const { formInput } = this.state;
    if (!formInput.enterprise) {
      return message.info('Please select enterprise');
    }
    if (formInput.cps.length < 1) {
      return message.info('Please select courier partner');
    }
    if (formInput.accounts.length < 1) {
      return message.info('Please select account');
    }
    if (!formInput.labelSize) {
      return message.info('Please select label size');
    }
    if (!formInput.sampleTemplate && !formInput.file.name) {
      return message.info('Please select shipping label template');
    }
    this.setState({ isSubmitting: true });
    let preUrl = `${shippingLabels.file.directory +
      parseInt(new Date().getTime() / 1000)}_${formInput.enterprise.id}`;
    if (formInput.file.type === 'text/html' || formInput.sampleTemplate) {
      preUrl += '.html';
    } else {
      preUrl += formInput.file.name;
    }
    let requestObjs = [];
    for (let index = 0; index < formInput.accounts.length; index++) {
      const obj = {
        enterprise_id: formInput.enterprise.id,
        account_id: formInput.accounts[index],
        file_upload: preUrl,
        label_size: formInput.labelSize,
        key: formInput.enterprise.key
      };
      const filteredAccount = this.props.metadata.account.list.filter(
        item => item.id === formInput.accounts[index]
      );
      if (filteredAccount.length > 0) {
        obj.cp_id = filteredAccount[0].cp_id;
        obj.title = `${filteredAccount[0].cp_name} - ${filteredAccount[0].name}`;
      }
      requestObjs.push(obj);
    }
    if (formInput.sampleTemplate) {
      this.props
        .replicateS3File({
          source: formInput.sampleTemplate,
          destination: preUrl
        })
        .then(res => {
          if (res.meta.status === 200) {
            this.shipppingLabelCreation(requestObjs);
          }
        });
    } else if (formInput.file.name) {
      getBase64(formInput.file, () => {
        this.props.preSignedUrl(preUrl).then(res => {
          if (res) {
            const { url, fields } = res;
            this.props
              .uploadFileToS3({ file: formInput.file, url, fields })
              .then(() => {
                this.shipppingLabelCreation(requestObjs);
              });
          }
        });
      });
    }
  };

  handleReset = () => {
    this.setState({
      formInput: { enterprise: null, cps: [], accounts: [], file: {} },
      result: []
    });
    this.htmlTemplate.current.value = null;
  };

  handleUpdate = idx => {
    const { result, formInput } = this.state;
    const { id, file_upload, label_size } = result[idx];
    this.props
      .putShippingLabels({
        id,
        file_upload,
        key: formInput.enterprise.key,
        label_size
      })
      .then(res => {
        if (res.meta.success) {
          result[idx].status = 'Success';
          delete result[idx].id;
          delete result[idx].message;
        }
        this.setState({ result });
      });
  };

  render() {
    const { formInput, result } = this.state;
    const { metadata } = this.props;
    const filteredAccounts = metadata.account.list.filter(item => {
      return formInput.cps.indexOf(item.cp_id) > -1;
    });
    return (
      <div>
        <h2>Create enterprise shipping label</h2>
        <Row className="margin-bottom-10">
          <Col span={3}>
            <span>Enterprise:</span>
          </Col>
          <Col span={21} className="margin-bottom-10">
            <Select
              showSearch
              style={{ width: '100%' }}
              placeholder="Please select an enterprise"
              optionFilterProp="children"
              value={
                this.state.formInput.enterprise
                  ? this.state.formInput.enterprise.name
                  : undefined
              }
              onChange={value => this.handleChange('enterprise', value)}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {metadata.enterprise.list.map((enterprise, i) => (
                <Option key={i} value={i}>
                  {enterprise.name}
                </Option>
              ))}
            </Select>
          </Col>
          <Col span={3}>
            <span>Courier Partner:</span>
          </Col>
          <Col span={21} className="margin-bottom-10">
            <Select
              placeholder="Please select courier partner"
              value={
                this.state.formInput.cps.length > 0
                  ? this.state.formInput.cps
                  : undefined
              }
              mode="multiple"
              style={{ width: '100%' }}
              onChange={value => this.handleChange('cps', value)}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {metadata.cp.list.map((cp, i) => (
                <Option key={i} value={cp.id}>
                  {cp.name}
                </Option>
              ))}
            </Select>
          </Col>
          <Col span={3}>
            <span>Account:</span>
          </Col>
          <Col span={21} className="margin-bottom-10">
            <Select
              placeholder="Please select account"
              mode="multiple"
              style={{ width: '100%' }}
              value={
                this.state.formInput.accounts.length > 0
                  ? this.state.formInput.accounts
                  : undefined
              }
              onChange={value => this.handleChange('accounts', value)}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {filteredAccounts.map((account, i) => (
                <Option key={i} value={account.id}>
                  {`${account.cp_name} - ${account.name}`}
                </Option>
              ))}
            </Select>
          </Col>
          {/* <Col span={3}>
            <span>Sample Template:</span>
          </Col>
          <Col span={21} className="margin-bottom-10">
            <Radio.Group
              name="sampleTemplate"
              value={this.state.formInput.sampleTemplate}
              onChange={this.handleRadioChange}
            >
              {metadata.sampleTemplate.list.map((template, i) => (
                <Radio
                  key={i}
                  value={template.file_upload}
                >{`${template.name}(${template.label_size})`}</Radio>
              ))}
            </Radio.Group>
          </Col> */}
          <Col span={3}>
            <span>Label Size:</span>
          </Col>
          <Col span={21} className="margin-bottom-10">
            <Radio.Group
              name="labelSize"
              value={this.state.formInput.labelSize}
              onChange={this.handleRadioChange}
            >
              {labelSizes.map((item, i) => (
                <Radio key={i} value={item.value}>
                  {item.label}
                </Radio>
              ))}
            </Radio.Group>
          </Col>
          <Col span={3}>
            <span>Upload:</span>
          </Col>
          <Col span={21} className="margin-bottom-20">
            <input
              type="file"
              ref={this.htmlTemplate}
              name="htmlTemplate"
              accept=".html"
              onChange={this.fileSelect}
            />
          </Col>
          <Col span={24} className="margin-bottom-20">
            <Button
              type="primary"
              onClick={this.handleSubmit}
              loading={this.state.isSubmitting}
            >
              Submit
            </Button>
            <Button
              style={{ marginLeft: 8 }}
              onClick={this.handleReset}
              disabled={this.state.isSubmitting}
            >
              Clear
            </Button>
          </Col>
          {result.length > 0 ? (
            <Col span={24} className="margin-bottom-10">
              <h2>Result:</h2>
              <table className="ant-table ant-table-small width-100pt">
                <thead className="ant-table-thead">
                  <tr>
                    <th>Account Name</th>
                    <th>Request Status</th>
                    <th>Message</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody className="ant-table-tbody">
                  {result.map((item, i) => (
                    <tr key={i}>
                      <td>{item.title}</td>
                      <td>{item.status}</td>
                      <td>{item.message}</td>
                      <td>
                        <Button
                          type="primary"
                          disabled={!item.id}
                          onClick={e => this.handleUpdate(i, e)}
                        >
                          Update
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Col>
          ) : null}
        </Row>
      </div>
    );
  }
}

CreateShippingLabels.propTypes = {
  shippingLabels: PropTypes.object,
  config: PropTypes.object,
  location: PropTypes.object,
  metadata: PropTypes.object,
  fetchShippingLabels: PropTypes.func,
  fetchCP: PropTypes.func,
  fetchActiveReportsMetaData: PropTypes.func,
  fetchSampleTemplates: PropTypes.func,
  uploadFileToS3: PropTypes.func,
  preSignedUrl: PropTypes.func,
  postShippingLabels: PropTypes.func,
  putShippingLabels: PropTypes.func,
  replicateS3File: PropTypes.func
};

CreateShippingLabels.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  config: state.session.config,
  metadata: state.session.metadata,
  shippingLabels: state.session.shippingLabels
});

const mapDispatchToProps = dispatch => ({
  fetchShippingLabels: query => dispatch(fetchShippingLabels(query)),
  fetchCP: query => dispatch(fetchCP(query)),
  fetchActiveReportsMetaData: query =>
    dispatch(fetchActiveReportsMetaData(query)),
  fetchSampleTemplates: () => dispatch(fetchSampleTemplates()),
  uploadFileToS3: query => dispatch(uploadFileToS3(query)),
  preSignedUrl: query => dispatch(preSignedUrl(query)),
  postShippingLabels: query => dispatch(postShippingLabels(query)),
  replicateS3File: query => dispatch(replicateS3File(query)),
  putShippingLabels: query => dispatch(putShippingLabels(query))
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CreateShippingLabels)
);
